export const urlRegExp = new RegExp(
	/((?:https?:\/\/)?(?:www\.|(?!www))?[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi
);
export const phoneRegExp = new RegExp(/[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}/gi);
export const ssnRegExp = new RegExp(/([1-9])(?!\1{2}-\1{2}-\1{4})[1-9]{2}-[1-9]{2}-[1-9]{4}/gi);
export const emailRegExp = new RegExp(
	/(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/gi
);
export const englishOnlyEmail = new RegExp(
	/^[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:[._+-][A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*@[A-Za-z0-9]+(?:[.-][A-Za-z0-9]+)*\.[a-z]{2,}$/
);
export const subdomainRegExp = new RegExp(/^[a-zA-Z0-9][a-zA-Z0-9]+[a-zA-Z0-9]$/);
export const numbersAndLettersRegExp = new RegExp(/[a-zA-Z0-9]/gi);
export const asteriskRegExp = new RegExp(/ \*/);
export const outputCapitalizeLettersRegexp = new RegExp(/(\b([A-Z]([^A-Z.\-_, ]|[^A-Z])([a-z]?)*)+)/g);
export const outputDateCapitalizeFormatRegexp = new RegExp(
	/(0[1-9]|1[0-9]|2[0-9]|3[0-1])?([-., /])(?:jan(?:uary)?|feb(?:ruary)?|mar(?:ch)?|apr(?:il)?|may|june?|july?|aug(?:ust)?|sep(?:tember)?|oct(?:ober)?|nov(?:ember)?|dec(?:ember)?)?([-., /]?[-., /])(1[0-9][0-9]\d|2[0-9][0-9]\d)/gi
);
export const firstLetterRegexp = new RegExp(/\b\w/g);
export const signatureDataUrlRegexp = new RegExp(
	/^data:image\/(?:gif|png|jpeg|bmp|webp|svg\+xml)(?:;charset=utf-8)?;base64,(?:[A-Za-z0-9]|[+/])+={0,2}/
);
export const egyptianNationalIDRegexp = new RegExp(
	/^([1-9]{1})([0-9]{2})([0-9]{2})([0-9]{2})([0-9]{2})[0-9]{3}([0-9]{1})[0-9]{1}$/
);
export const googleMapUrlRegexp = new RegExp(/^https?:\/\/maps\.app\.goo\.gl\/[A-Za-z0-9]+$/);
export const faxNumberRegexp = new RegExp(/^\+?[0-9]{6,}$/);
